<template>
  <div v-if="!loading">
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        searchnew: this.search,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:new="createHandler"
      v-on:save="saveHandler"
      v-on:delete="isConfirm = !isConfirm"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
    <div v-if="isConfirm">
      <app-confirm
        v-bind:parentObject="{
          pageTitleValue: this.pageTitleValue,
          isConfirm: this.isConfirm,
        }"
        v-on:confirm="deleteHandler($event)"
        v-on:cancelConfirm="isConfirm = !isConfirm"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import ThisForm from "../../../components/payroll/eissub/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": ThisForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('alleis.editeissubmissionrec'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadEisHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/eissubmissionrecord/" + this.id})
        .then((res) => {
          vm.formData = res.data.rec[0];

          vm.pageTitleValue = res.data.rec[0].eissubreccode;
          vm.formData.userid = this.$store.getters.userId;

          // if vm.loading = false, the next detail would not be loaded into the form
        //  vm.headLoading = false;

          vm.loadEisDetailPayHandler();
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadEisDetailPayHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/eissubmissionrecordpy/" + this.id})
        .then((res) => {
          vm.formData.eissubrecpay = res.data.rec;

           for (let i = 0; i < vm.formData.eissubrecpay.length; i++) {
            Object.assign(vm.formData.eissubrecpay[i], { action: 2 });
          }

          vm.loadEisDetailRefHandler();

          // vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadEisDetailRefHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/eissubmissionrecordref/" + this.id})
        .then((res) => {
          vm.formData.eissubrecref = res.data.rec;

          for (let i = 0; i < vm.formData.eissubrecref.length; i++) {
            if (vm.formData.eissubrecref[i].receiptdate) {
              vm.formData.eissubrecref[i].receiptdate = moment(
                vm.formData.eissubrecref[i].receiptdate
              ).format("YYYY-MM-DD");
            }

          }

          
          for (let i = 0; i < vm.formData.eissubrecref.length; i++) {
            Object.assign(vm.formData.eissubrecref[i], { action: 2 });
            Object.assign(vm.formData.eissubrecref[i], { no: i + 1 });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
        this.$router.push({name: 'eissubnew'});
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/eissubmissionrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "eissublist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "eissublist" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/eissubmissionrecord/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "eissublist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  mounted() {
    this.loadEisHandler(); //header
    //this.loadEisDetailPayHandler(); // data table items
   // this.loadEisDetailRefHandler(); // crud table items
  },
};
</script>